import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "subpathitem"
    }}>{`SubPathItem`}</h1>
    <p>{`Represents a subpath; a collection of subpaths make up a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{`.`}</p>
    <p>{`Create these objects by passing `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` objects to `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
      }}>{`PathItems.add`}</a>{`() method. This method creates a
`}<inlineCode parentName="p">{`SubPathItem`}</inlineCode>{` object for each `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` object, and creates and then returns a new `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{` object for the
path represented by all of the subpaths. Access these objects in the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/#subpathitems"
      }}>{`PathItem.subPathItems`}</a>{` collection.`}</p>
    <ul>
      <li parentName="ul">{`Use the `}<a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
        }}>{`SubPathItem`}</a>{` object to retrieve information about existing subpaths. The properties are read-only.`}</li>
      <li parentName="ul">{`Use `}<a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
        }}>{`SubPathInfo`}</a>{` to create subpaths; the properties are read-write.`}</li>
    </ul>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`closed`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True if the path is closed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`operation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#shapeoperation"
            }}><em parentName="a">{`ShapeOperation`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`How this `}{`\``}{`SubPathItem`}{`\``}{` behaves when it intersects another. Specifies how to combine the shapes if the destination path already has a selection.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
            }}><em parentName="a">{`PathItem`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The path this subpath belongs to`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pathPoints`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/pathpoints/"
            }}><em parentName="a">{`PathPoints`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The collection of the `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/pathpoint/"
            }}>{`PathPoint`}</a>{`s on this `}{`\``}{`SubPathItem`}{`\``}{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced PathItem object`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      